export const VALUE_SEPARATOR = ',';
export const LINE_SEPARATOR = '\n';
